import {EventBus} from '@client/event-bus'
import {backFromChatEvent} from '@client/events'
import {rightPanelStore} from '@components/right-panel/right-panel'
import {ChatUtils} from '@extensions/chat-utils'

interface Handlers {
  createGroup: () => void
}

export const useCreateGroup = (): Handlers => {
  const createGroup = (): void => {
    EventBus.dispatch(backFromChatEvent())
    ChatUtils.restoreChat()
    setTimeout(() => {
      rightPanelStore.setGroupChatEdit(true)
    }, 200)
  }

  return {createGroup}
}
